var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFishingL(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2124 100.777L35 84.5833H113.75C118.583 84.5833 122.5 88.5006 122.5 93.3333C122.5 98.1659 118.583 102.083 113.75 102.083H65.8114C64.1868 102.083 62.5946 101.631 61.2124 100.777Z",
    stroke: "#C08552",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 32.0833C90.7218 32.0833 93.3334 29.4717 93.3334 26.25C93.3334 23.0283 90.7218 20.4166 87.5 20.4166C84.2783 20.4166 81.6667 23.0283 81.6667 26.25C81.6667 29.4717 84.2783 32.0833 87.5 32.0833Z",
    stroke: "#C08552",
    strokeWidth: 7,
    strokeMiterlimit: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.167 93.3333C110.833 84.5833 106.459 65.4313 103.542 59.7916C100.625 54.152 94.9358 46.6666 94.9358 46.6666C94.9358 46.6666 91.8753 46.6666 88.9587 49.5833C81.1461 57.3959 75.8337 67.0833 68.542 67.0833C61.2503 67.0833 51.042 61.25 51.042 61.25",
    stroke: "#C08552",
    strokeWidth: 7,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3348 43.7499C47.8441 30.6372 39.711 24.5985 23.3348 23.5142C20.1202 23.3014 17.5003 25.945 17.5003 29.1666V81.6666",
    stroke: "#C08552",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4167 125.417C32.0834 125.417 28.9844 119.583 37.9167 119.583C46.849 119.583 43.75 125.417 53.9584 125.417C64.1667 125.417 61.25 119.583 71.4584 119.583C81.6667 119.583 80.0261 125.417 88.9583 125.417C97.8906 125.417 93.3333 119.583 103.542 119.583C113.75 119.583 111.016 125.417 122.5 125.417",
    stroke: "#C08552",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishingL);
export default __webpack_public_path__ + "static/media/fishingL.467dc5d32d68e9f24c2ae15b3aab41b2.svg";
export { ForwardRef as ReactComponent };